import React, { useEffect, useRef } from "react";
import lottie from "lottie-web";

const RiderLottie = () => {
  const container = useRef(null);

  useEffect(() => {
    lottie.loadAnimation({
      container: container.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: require("../../Rider-lottie.json"),
    });
  }, []);

  return (
    <div>
      <div
        className="container"
        ref={container}
        style={{ width: "300px", height: "200px" }}
      ></div>
    </div>
  );
};

export default RiderLottie;
